import React from 'react';
import Image from 'next/image';
import Link from '../Link';
import ControlesCarrito from '../ControlesCarrito';
import { Button } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { currency } from '../../utils/utils';
import useHook from './useHook';
import { Producto } from '../../models/Producto';
import styles from './styles.module.scss';

type ItemProductoV2Props = {
    data: Producto
    isCarousel?: boolean
}

const ItemProductoV2 = ({ data: producto, isCarousel }: ItemProductoV2Props) => {

  const {
    hovered,
    setHovered,
    cantidadEnCarrito,
    esFavorito,
    mainImage,
    hoverImage,
    handleAgregar,
    handleFavorito,
    handleImageClick,
  } = useHook(producto);

  const href = `/productos/${producto.attributes?.slug}`;

  return (
    <div className={`${styles.item} ${isCarousel ? styles.itemCarousel : ''}`}>
      {producto.attributes?.novedad && <div className={styles.cucarda}>¡Novedad!</div>}
      <Link href={href}>
        <div className={styles.arriba}>
          <Image
            className={styles.imagenProducto}
            src={hovered ? hoverImage : mainImage}
            alt={producto.attributes?.nombre || 'Producto We Celebrate!'}
            width={272}
            height={342}
            onClick={handleImageClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          />
          <button
            className={styles.favButton}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleFavorito();
            }}
            aria-label={esFavorito ? 'Quitar de mi wishlist' : 'Agregar a mi wishlist'}
          >
            {esFavorito ? <FavoriteIcon style={{ color: '#333' }} /> : <FavoriteBorderIcon style={{ color: '#333' }} />}
          </button>
          {cantidadEnCarrito > 0 && <CheckCircleIcon className={styles.badgeAgregado} />}
        </div>
      </Link>
      <div className={styles.abajo}>
        <Link href={href}>
          <h3 className={styles.nombre} title={producto.attributes?.nombre}>{producto.attributes?.nombre || '-'}</h3>
        </Link>

        <div className={styles.contenedorPrecios}>
          <span className={styles.precio}>$ {currency(producto.attributes?.precioFinal)}</span>
        </div>

        {cantidadEnCarrito === 0 ? (
          <Button
            variant="contained"
            color="otherPink2"
            style={{ width: '100%', height: '40px', marginBottom: '12px' }}
            startIcon={<ShoppingCartOutlinedIcon />}
            onClick={handleAgregar}
          >
            <span className={styles.textoBotonDesktop}>Agregar</span>
            <span className={styles.textoBotonMobile}>Agregar</span>
          </Button>
        ) : (
          <div className={styles.controlesWrapper}>
            <ControlesCarrito producto={producto} leftAlign={true} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemProductoV2;
